import type { ReactNode } from 'react';
import { cx } from '../cx';

export type StatTileProps = {
  label: ReactNode;
  /** Already locale-formatted (formatNumber, formatMoney). */
  value: ReactNode;
  /** What the figure means, in one line. */
  meaning?: ReactNode;
  /** Where the figure comes from and when. Required: no source, no tile. */
  source: ReactNode;
  className?: string;
};

/** One figure, what it means, and where it comes from. Squarer than a card: information, not a control. */
export function StatTile({ label, value, meaning, source, className }: StatTileProps) {
  // No source, no tile.
  if (source == null || source === '' || source === false) return null;
  return (
    <div
      className={cx(
        'flex flex-col gap-1 rounded-jc-info bg-jc-surface p-4 ring-1 ring-inset ring-jc-card-border',
        className,
      )}
    >
      <span className="type-eyebrow text-jc-ink-secondary">{label}</span>
      <span className="type-figure text-jc-ink">{value}</span>
      {meaning ? <span className="text-sm text-jc-ink-secondary">{meaning}</span> : null}
      <span className="mt-auto pt-2 text-xs text-jc-ink-secondary">{source}</span>
    </div>
  );
}
